import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { ApiError } from "../api/client";
import { reviewApi } from "../api/review";

/** Renders children only for a signed-in, active reviewer. */
export function ReviewerGate({ children }: { children: ReactNode }) {
  const me = useQuery({ queryKey: ["review", "me"], queryFn: reviewApi.me, retry: false });
  if (me.isPending) return <main className="page">Loading…</main>;
  if (me.isError) {
    const denied = me.error instanceof ApiError && me.error.status === 403;
    return (
      <main className="page">
        <h1>Review console</h1>
        {denied ? (
          <p role="alert">This GitHub account isn't on the reviewer list.</p>
        ) : (
          <p>
            <a className="button" href="/auth/github/reviewer">
              Sign in with GitHub
            </a>
          </p>
        )}
      </main>
    );
  }
  return <>{children}</>;
}
